import axios from "axios";
import { put } from "redux-saga/effects";
import { undo } from "../../../helpers/undoable";
import { PagesService } from "../../../services/pages";
import { updatePageDataFailure, updatePageDataSuccess } from "../actionCreators";
import { UpdatePageDataRequestActionType } from "../types";
import { IErrorType } from "./../../types/errors.d";
import { refreshLayout } from "../../layout/actionCreators";

export function* UpdatePageDataSaga(action: UpdatePageDataRequestActionType) {
    const { payload } = action;

    try {
        yield PagesService.updatePageData(payload);

        yield put(updatePageDataSuccess({}));
        yield put(refreshLayout({}));
    } catch (error) {
        yield put(undo(action));

        if (axios.isAxiosError(error))
            yield put(updatePageDataFailure({ data: error.response?.data, errorType: IErrorType.AXIOS }));
        else yield put(updatePageDataFailure({ data: {}, errorType: IErrorType.NATIVE }));
    }
}
